import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CourseTrackService {
private token2="a6a83a30-b51d-4bea-8af3-ac4a5cdae54c"

  constructor(public http: HttpClient) 
  {  const headers = new HttpHeaders({
    'Authorization': `${ this. token2}`
  });}
 
  getcoursetrake(){
    // const headers = new HttpHeaders({
    //   'Authorization': 'Bearer '+ this.token2,
    // });
    // const headers = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': `Bearer ${this.token2}`
    // })
    return  this.http.get( environment.CourseFeeUrl+"/courseTrack/details",) 
  }
  getsave(payload:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+ this.token2,
    });
    return  this.http.post( environment.CourseFeeUrl+"/courseTrack/saveCTDetails",payload ,{headers}) 
  }
  gettable(filterBy:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+ this.token2,
    });
    return  this.http.get(  environment.CourseFeeUrl+"/courseTrack/ctApproval?filterBy="+filterBy,{headers}) 
   
  }
  status(APPORVAL:any,data2:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+ this.token2,
    });
    return  this.http.post( environment.CourseFeeUrl+"/courseTrack/saveCTApprovalDetails?courseTrackId="+APPORVAL, data2,{headers}) 
  }
}
